import React from 'react';

const CircularProgress = ({ size = 40 }) => {
    const style = { width: size, height: size };
    return (React.createElement("svg", { className: "base-circular-progress", viewBox: "0 0 50 50", style: style },
        React.createElement("circle", { className: "base-circular-progress-path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })));
};

export { CircularProgress as default };
//# sourceMappingURL=index.js.map
